import { NavLink } from "react-router-dom";
import { Home, Radar, Plus, MessageSquare, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Floating-pill bottom nav (mobile only).
 * The center tab now reads "List Item" — labelled action, not just a "+".
 * Slightly shorter to free up viewport for listings.
 */
export default function MobileBottomNav() {
  const { user } = useAuth();

  const itemCls = ({ isActive }) =>
    `flex flex-col items-center justify-center gap-0.5 flex-1 py-1 text-[10px] tracking-wide uppercase transition-colors ${
      isActive ? "text-[#0654BA]" : "text-stone-400 hover:text-stone-700"
    }`;

  return (
    <nav
      className="md:hidden fixed bottom-2 left-2 right-2 z-40"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="bg-white/95 backdrop-blur-xl border border-[#E2E2E2] rounded-full px-3 py-1.5 shadow-[0_8px_32px_-12px_rgba(15,23,42,0.16)] flex items-stretch gap-1">
        <NavLink to="/" end className={itemCls} data-testid="bottom-nav-home">
          <Home className="w-[18px] h-[18px]" strokeWidth={1.75} />
          <span>Home</span>
        </NavLink>
        <NavLink to={user ? "/what-can-i-get" : "/login"} className={itemCls} data-testid="bottom-nav-what-can-i-get">
          <Radar className="w-[18px] h-[18px]" strokeWidth={1.75} />
          <span>Match</span>
        </NavLink>

        {/* Center action — labelled List Item */}
        <NavLink to="/post" className="flex items-center justify-center flex-1" data-testid="bottom-nav-post">
          {({ isActive }) => (
            <div className={`flex items-center gap-1 px-3 py-1.5 rounded-full font-bold text-[11px] tracking-wide uppercase transition-all ${
              isActive
                ? "bg-[#F5AF02] text-slate-900"
                : "bg-[#0654BA] text-white hover:bg-[#0445A0]"
            }`}>
              <Plus className="w-4 h-4" strokeWidth={2.5} />
              <span>List Item</span>
            </div>
          )}
        </NavLink>

        <NavLink to={user ? "/messages" : "/login"} className={itemCls} data-testid="bottom-nav-messages">
          <MessageSquare className="w-[18px] h-[18px]" strokeWidth={1.75} />
          <span>Inbox</span>
        </NavLink>
        <NavLink to={user ? "/me" : "/login"} className={itemCls} data-testid="bottom-nav-profile">
          <User className="w-[18px] h-[18px]" strokeWidth={1.75} />
          <span>You</span>
        </NavLink>
      </div>
    </nav>
  );
}
